export const HOST = {
  name: "Almah Stays",
  firstName: "Almah Stays",
  role: "Superhost · Melbourne CBD",
  location: "Melbourne CBD, Australia",
  rating: "4.89",
  reviewsTotal: "37",
  responseRate: "100%",
  responseTime: "Within an hour",
  languages: "English · Malay · Albanian",
  airbnbProfile: "https://www.airbnb.com.au/users/profile/1651857286786092914",
  brand: "ALMAH Stays",
  portrait:
    "https://a0.muscache.com/im/pictures/user/User/original/7b7a233d-2043-4e07-9bcb-fc3cf794a8e7.jpeg?im_w=960",
  portraitAlt: "Almah Stays hosts, husband and wife team",
  heroImage:
    "https://a0.muscache.com/im/pictures/hosting/Hosting-1791116181419711800/original/b28ffd5f-4be9-47ff-9185-e4de4beb641b.jpeg?im_w=1440",
  bio: [
    "We're a husband and wife passionate about creating spaces that feel calm, comfortable, and welcoming. Through ALMAH Stays, we've designed each home with care so guests can unwind, recharge, and enjoy a stay that feels just like home.",
    "Perched high above Melbourne's CBD, our apartments pair warm, earthy interiors with floor-to-ceiling skyline views — moments from Southern Cross Station, the free tram zone, and the city's best coffee. We answer every message within the hour, because hosting is personal to us.",
  ],
};

export const PROPERTIES = [
  {
    id: "skyline-haven",
    name: "Secret 2BR CBD Skyline Haven",
    location: "Rose Lane, Melbourne CBD VIC",
    capacity: "6 Guests · 2 Bedrooms · 3 Beds · 1 Bath",
    description:
      "Arrive, drop your bags and instantly feel at ease. Cosy lounge, morning-coffee balcony, warm earthy tones and hotel-style comfort as the city lights glow. Pool, gym and sauna included.",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1651857285922639282/original/899d99f8-845c-43e7-832a-cd5402ed85c1.png?im_w=1200",
    airbnbUrl: "https://www.airbnb.com.au/rooms/1651857285922639282",
    rating: "4.89",
    reviewsCount: 19,
  },
  {
    id: "skyline-retreat",
    name: "Premium 2B CBD Skyline Retreat",
    location: "Melbourne CBD VIC",
    capacity: "5 Guests · 2 Bedrooms · 2 Beds · 1 Bath",
    description:
      "A luxe 23rd-floor skyline stay — private balcony coffee, warm earthy interiors and Melbourne lighting up below. Steps to Southern Cross Station and the Free Tram Zone. A certified guest favourite.",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1677987077391216751/original/ff80a63b-ff05-4df4-982f-26c6a80acf04.png?im_w=1200",
    airbnbUrl: "https://www.airbnb.com.au/rooms/1677987077391216751",
    rating: "4.89",
    reviewsCount: 18,
  },
  {
    id: "skyline-views",
    name: "Breathtaking 2BR Skyline Views",
    location: "Melbourne CBD VIC",
    capacity: "6 Guests · 2 Bedrooms · 3 Beds · 1 Bath",
    description:
      "Our newest stay — a 44th-floor retreat with floor-to-ceiling skyline views, a plush emerald sofa, and access to two heated pools, gyms and sauna. Moments from Southern Cross Station.",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1791116181419711800/original/b94e199f-ec79-4375-8f55-ea328e4e30bb.jpeg?im_w=1200",
    airbnbUrl: "https://www.airbnb.com.au/rooms/1791116181419711800",
    badge: "New listing",
  },
];

export const REVIEWS = [
  {
    id: "rev-1",
    author: "Nina",
    location: "Wells-next-the-Sea, United Kingdom",
    stayDate: "October 2026",
    property: "Premium 2B CBD Skyline Retreat",
    rating: 5,
    text: "Almah Stays was perfect for a weekend away. With a fantastic location, just across the road from Southern Cross Station, it suited all of our needs. The host was very, very helpful — reaching out with information and answering any questions we had. Would recommend, and we'll book again next time we visit!",
  },
  {
    id: "rev-2",
    author: "Emily",
    location: "Australia",
    stayDate: "October 2026",
    property: "Secret 2BR CBD Skyline Haven",
    rating: 5,
    text: "Great base from which to explore Melbourne. My family loved our stay and the indoor pool was an added bonus for the kids. Very convenient for transfers to and from the airport from Southern Cross Station. Highly recommend!",
  },
  {
    id: "rev-3",
    author: "Nathan",
    location: "Balga, Australia",
    stayDate: "October 2026",
    property: "Premium 2B CBD Skyline Retreat",
    rating: 5,
    text: "Great location, communication was fantastic and a few minor issues were resolved quickly and without hassle. Would definitely stay there again.",
  },
  {
    id: "rev-4",
    author: "Chante Leatitia",
    location: "Australia",
    stayDate: "September 2026",
    property: "Secret 2BR CBD Skyline Haven",
    rating: 5,
    text: "The apartment was lovely, clean & warm. It was peaceful and quiet and a very convenient location. Such wonderful hosts and hospitality — quick responses and very understanding. Such kind and genuine people. An overall lovely experience.",
  },
  {
    id: "rev-5",
    author: "Sharon",
    location: "Australia",
    stayDate: "October 2026",
    property: "Secret 2BR CBD Skyline Haven",
    rating: 5,
    text: "The host is super nice and the response is very clear and quick. The location of the apartment is good, just within a 5-minute walk to the SkyBus station. I truly recommend staying here if you would like to stay at Melbourne CBD.",
  },
  {
    id: "rev-6",
    author: "Anthony",
    location: "Rozelle, Australia",
    stayDate: "October 2026",
    property: "Premium 2B CBD Skyline Retreat",
    rating: 5,
    text: "This apartment was very clean, incredible value and the pools and bouldering room are great for families. Our host was very accommodating and we had wonderful communication overall. A great location and great stay! Thank you Almah Stays!",
  },
  {
    id: "rev-7",
    author: "Phuong",
    location: "Australia",
    stayDate: "October 2026",
    property: "Secret 2BR CBD Skyline Haven",
    rating: 5,
    text: "Great stay and location, the host was super friendly and helpful. Would definitely stay again!",
  },
  {
    id: "rev-8",
    author: "Elka",
    location: "Canberra, Australia",
    stayDate: "October 2026",
    property: "Secret 2BR CBD Skyline Haven",
    rating: 5,
    text: "Lovely apartment, convenient location.",
  },
];

export const MARQUEE_ITEMS = [
  "Melbourne CBD",
  "Southern Cross Station",
  "Superhost",
  "4.89 Guest Rating",
  "37 Guest Reviews",
  "Skyline Views",
  "Heated Pool · Gym · Sauna",
  "Self Check-in",
  "Free Tram Zone",
];
